
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship-luggage-internationally",
      function () {
        return require("private-next-pages/ship-luggage-internationally/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ship-luggage-internationally"])
      });
    }
  